import { useContext } from "react";
import {
  DocumentEditorContext,
  type DocumentEditorContextValue,
} from "@/pages/dokumente/documentEditorContextValue";

export function useDocumentEditor(): DocumentEditorContextValue {
  const ctx = useContext(DocumentEditorContext);
  if (!ctx) {
    throw new Error(
      "useDocumentEditor() muss innerhalb von <DocumentEditorProvider> verwendet werden.",
    );
  }
  return ctx;
}
